const initializeMobilePurchaseBar = () => {
  const bar = document.querySelector('[data-lq-mobile-purchase]');
  if (!bar) return;

  const variantInput = bar.querySelector('input[name="id"]');
  const submitButton = bar.querySelector('[data-lq-mobile-submit]');
  const price = bar.querySelector('[data-lq-mobile-price]');
  const selection = bar.querySelector('[data-lq-mobile-selection]');
  const mainPurchase = document.querySelector('main[data-template^="product"] .buy-buttons-block');

  const updateSelection = () => {
    if (!selection) return;

    const optionValues = Array.from(document.querySelectorAll('main[data-template^="product"] .variant-option')).map((option) => {
      const selectedInput = option.querySelector('input:checked');
      const selectedOption = option.querySelector('option:checked');
      const selectedControl = selectedInput || selectedOption;
      if (!selectedControl) return null;

      const selectedLabel = selectedControl.closest('label');
      return selectedLabel?.querySelector('[data-lq-choice-label]')?.textContent?.trim() || selectedControl.value?.trim();
    }).filter(Boolean);

    selection.textContent = optionValues.join(' · ');
  };

  updateSelection();

  document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.resource;
    if (!variant) return;

    if (variantInput && variant.id) variantInput.value = variant.id;
    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available ? submitButton.dataset.availableText : submitButton.dataset.soldOutText;
    }

    const sourcePrice = event.detail?.data?.html?.querySelector('product-price [ref="priceContainer"]');
    if (price && sourcePrice) price.innerHTML = sourcePrice.innerHTML;
    window.requestAnimationFrame(updateSelection);
  });

  if (!mainPurchase || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];
    const hasPassedPurchase = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', hasPassedPurchase);
  }, { threshold: 0.05 });

  observer.observe(mainPurchase);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMobilePurchaseBar, { once: true });
} else {
  initializeMobilePurchaseBar();
}
